module.exports = __webpack_public_path__ + "static/media/2-Hearts.1f4c2acc.svg";